import React, { useState, useEffect } from 'react';

function Landing({ navigate, user }) {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const h = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  return (
    <div style={s.root}>
      <link href="https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Noto+Sans+KR:wght@300;400;500;700&display=swap" rel="stylesheet" />
      <nav style={{ ...s.nav, backgroundColor: scrollY > 50 ? 'rgba(10,18,32,0.95)' : 'transparent', backdropFilter: scrollY > 50 ? 'blur(20px)' : 'none' }}>
        <div style={s.navInner}>
          <div style={s.logoGroup} onClick={() => navigate('landing')}>
            <span style={{ fontSize: 24 }}>🏒</span>
            <span style={s.logoText}>IonIce</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 28 }}>
            <a href="#features" style={s.navLink}>Features</a>
            <a href="#platforms" style={s.navLink}>Platforms</a>
            <button onClick={() => navigate(user ? 'dashboard' : 'login')} style={s.navBtn}>
              {user ? 'Dashboard' : 'Sign In'}
            </button>
          </div>
        </div>
      </nav>

      <section style={s.hero}>
        <div style={s.heroBg} />
        <div style={s.heroContent}>
          <div style={s.heroTag}>Ice Hockey Team Management Platform</div>
          <h1 style={s.heroTitle}>Your Team,<br /><span style={s.heroAccent}>On Ice.</span></h1>
          <p style={s.heroDesc}>아이스하키 동호회를 위한 올인원 팀 관리 플랫폼.<br />일정 관리, 출석 체크, 경기 통계, 스마트워치 연동까지.</p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', alignItems: 'center' }}>
            <button onClick={() => navigate(user ? 'dashboard' : 'login')} style={s.heroMainBtn}>
              {user ? '대시보드 열기' : '시작하기'}
            </button>
            <a href="#features" style={{ color: '#8899AA', padding: '14px 24px', fontSize: 15 }}>더 알아보기 ↓</a>
          </div>
        </div>
      </section>

      <section id="features" style={{ padding: '100px 24px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={s.sTag}>FEATURES</div>
          <h2 style={s.sTitle}>팀 운영에 필요한 모든 것</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
            {features.map((f, i) => (
              <div key={i} style={s.fCard}>
                <div style={{ fontSize: 32, marginBottom: 16 }}>{f.icon}</div>
                <h3 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 10px' }}>{f.title}</h3>
                <p style={{ fontSize: 14, lineHeight: 1.7, color: '#778899', margin: 0 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="platforms" style={{ padding: '100px 24px', backgroundColor: 'rgba(91,196,216,0.02)' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={s.sTag}>PLATFORMS</div>
          <h2 style={s.sTitle}>어디서든 연결되는 플랫폼</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 20 }}>
            {platforms.map((p, i) => (
              <div key={i} style={s.pCard}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>{p.icon}</div>
                <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 6 }}>{p.name}</div>
                <div style={{ fontSize: 12, color: '#5BC4D8' }}>{p.status}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer style={s.footer}>
        <div style={s.footerInner}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 40 }}>
            <div>
              <div style={s.logoGroup}><span style={{ fontSize: 24 }}>🏒</span><span style={s.logoText}>IonIce</span></div>
              <div style={{ color: '#556677', fontSize: 12, lineHeight: 1.8, marginTop: 12 }}>
                <div>상호명: 코스모소나플렉스 유한회사 | 대표자: 손태무</div>
                <div>사업자등록번호: 655-87-02376 | 통신판매업신고: 제 2025-서울중구-627호</div>
                <div>주소: 서울특별시 중구 마른내로4가길 17, 인현동L빌딩 301호</div>
                <div>전화: 070-8287-2854 | 이메일: admin@ionice.hockey</div>
              </div>
              <p style={{ color: '#445566', fontSize: 11, margin: '12px 0 0' }}>© 2026 CosmoSonaflex LC. All rights reserved.</p>
            </div>
            <div style={{ display: 'flex', gap: 24 }}>
              <a href="/privacy.html" style={{ color: '#778899', fontSize: 13, textDecoration: 'none' }}>Privacy Policy</a>
              <span onClick={() => navigate('refund')} style={{ color: '#778899', fontSize: 13, cursor: 'pointer' }}>취소/환불 규정</span>
              <a href="mailto:admin@ionice.hockey" style={{ color: '#778899', fontSize: 13 }}>Contact</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

const features = [
  { icon: '📅', title: '일정 관리', desc: '훈련, 경기, 이벤트 일정을 한눈에 관리하고 팀원에게 자동으로 알림을 보냅니다.' },
  { icon: '✅', title: '출석 체크', desc: '참석/불참 투표로 인원을 미리 파악하고, 실제 출석을 기록합니다.' },
  { icon: '📊', title: '경기 통계', desc: '골, 어시스트, 출전 시간 등 개인 및 팀 통계를 자동으로 추적합니다.' },
  { icon: '⌚', title: '스마트워치 연동', desc: 'Garmin 워치에서 실시간 경기 기록과 심박수 데이터를 자동 수집합니다.' },
  { icon: '👥', title: '팀 관리', desc: '코치, 운영자, 선수 역할별 기능을 제공하며 초대 코드로 간편하게 팀에 참가합니다.' },
  { icon: '💰', title: '정산 관리', desc: '참가비 수납, 팀 재정 관리를 투명하게 운영합니다.' },
  { icon: '📷', title: '미디어 갤러리', desc: '경기/훈련 사진과 영상을 팀 갤러리에 업로드하고 공유합니다.' },
  { icon: '📋', title: '게시판 & 투표', desc: '공지사항, 자유게시판, 팀 투표로 효율적인 소통을 지원합니다.' },
  { icon: '🏟️', title: '아이스링크 정보', desc: '전국 아이스링크 시설 정보, 운영시간, 평점을 한눈에 확인합니다.' },
];

const platforms = [
  { icon: '📱', name: 'iOS App', status: '개발중' },
  { icon: '🤖', name: 'Android App', status: '개발중' },
  { icon: '🌐', name: 'Web Portal', status: '운영중' },
  { icon: '⌚', name: 'Garmin Watch', status: '개발완료' },
  { icon: '🖥️', name: 'iPad Coach', status: '계획중' },
];

const s = {
  root: { fontFamily: "'Noto Sans KR', sans-serif", backgroundColor: '#0A1220', color: '#E8ECF1', minHeight: '100vh' },
  nav: { position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, transition: 'all 0.3s', borderBottom: '1px solid rgba(91,196,216,0.08)' },
  navInner: { maxWidth: 1200, margin: '0 auto', padding: '16px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  logoGroup: { display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' },
  logoText: { fontSize: 24, fontWeight: 700, color: '#5BC4D8', fontFamily: "'Rajdhani', sans-serif", letterSpacing: 2 },
  navLink: { color: '#8899AA', fontSize: 14, fontWeight: 500, letterSpacing: 0.5 },
  navBtn: { padding: '8px 24px', borderRadius: 6, border: '1px solid #5BC4D8', backgroundColor: 'transparent', color: '#5BC4D8', fontSize: 14, fontWeight: 600, cursor: 'pointer', letterSpacing: 0.5 },
  hero: { position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' },
  heroBg: { position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 30% 50%, rgba(91,196,216,0.06) 0%, transparent 60%)' },
  heroContent: { position: 'relative', zIndex: 2, textAlign: 'center', maxWidth: 700, padding: '0 24px' },
  heroTag: { display: 'inline-block', padding: '6px 16px', borderRadius: 20, border: '1px solid rgba(91,196,216,0.2)', color: '#5BC4D8', fontSize: 12, fontWeight: 600, letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 32 },
  heroTitle: { fontSize: 64, fontWeight: 700, lineHeight: 1.1, fontFamily: "'Rajdhani', sans-serif", color: '#fff', margin: '0 0 24px', letterSpacing: -1 },
  heroAccent: { color: '#5BC4D8', textShadow: '0 0 60px rgba(91,196,216,0.3)' },
  heroDesc: { fontSize: 17, lineHeight: 1.8, color: '#8899AA', margin: '0 0 40px' },
  heroMainBtn: { padding: '14px 36px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #5BC4D8, #4AABB8)', color: '#0A1220', fontSize: 16, fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 24px rgba(91,196,216,0.25)' },
  sTag: { color: '#5BC4D8', fontSize: 12, fontWeight: 700, letterSpacing: 3, marginBottom: 12, textAlign: 'center' },
  sTitle: { fontSize: 36, fontWeight: 700, textAlign: 'center', margin: '0 0 60px', color: '#fff', fontFamily: "'Rajdhani', 'Noto Sans KR', sans-serif" },
  fCard: { backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(91,196,216,0.08)', borderRadius: 12, padding: 32 },
  pCard: { textAlign: 'center', padding: '32px 16px', backgroundColor: 'rgba(255,255,255,0.02)', border: '1px solid rgba(91,196,216,0.06)', borderRadius: 12 },
  footer: { padding: '40px 24px', borderTop: '1px solid rgba(91,196,216,0.06)' },
  footerInner: { maxWidth: 1100, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
};

export default Landing;
